import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import PortfolioJobsInquirySectionProfilePrivacyHint from './PortfolioJobsInquirySectionProfilePrivacyHint/PortfolioJobsInquirySectionProfilePrivacyHint.vue';
import PortfolioJobsInquirySectionProfileSection from './PortfolioJobsInquirySectionProfileSection.vue';
import { getProfileConfig } from './utils';
import type { CurrentUser, JobsInquiry } from '@/types/graphql';

type PortfolioJobsInquirySectionProfileProps = {
  inquiry: JobsInquiry;
  user: CurrentUser;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioJobsInquirySectionProfile',
  props: {
    inquiry: null,
    user: null
  },
  setup(__props: any) {

const props = __props as {
  inquiry: JobsInquiry;
  user: CurrentUser;
};



const profileConfig = computed(() =>
  getProfileConfig({
    inquiry: props.inquiry,
    user: props.user,
  }),
);

return { __sfc: true,props, profileConfig, PortfolioJobsInquirySectionProfilePrivacyHint, PortfolioJobsInquirySectionProfileSection }
}

})